<template>
  <div>
    <van-search v-if="search" placeholder="搜索关键词" v-model="searchModel[tabTitle.prop]" @search=onRefresh />
    <van-pull-refresh  v-model="refreshing" @refresh="onRefresh">
      <van-list v-model="loading"
                :finishedText="finishedText"
                :finished="finished"
                :loading-text="loadingText"
                @load="onLoad">
        <van-collapse v-if="type==='list'" v-model="activeName" :accordion=accordion?true:false>
          <van-collapse-item  v-for="(item, index) in list" :key="index" :name="index">
            <div slot="title" style="color:#666">{{tabTitle.name}}<span style="color:black">{{item[tabTitle.prop]}}</span></div>
            <van-row style="padding-left:.5rem;line-height: 2;">
              <van-col :span="12" v-for="(tabItem, index) in tabColumns" :key="index">{{tabItem.label}}:<span style="color:black">{{item[tabItem.prop]}}</span></van-col>
            </van-row>
            <van-row style="padding-left:.5rem;">
              <van-col :span="12" v-for="(opItem, index) in operation" :key="index"  v-if="show(opItem,item)">
                <van-button style="margin-left: 70%" v-if="operation.length===1" :type=opItem.type plain hairline size="small" @click="opItem.method(item)">{{opItem.text}}</van-button>
                <van-button v-else :type=opItem.type plain hairline size="mini" @click="opItem.method(item)">{{opItem.text}}</van-button>
              </van-col>
            </van-row>
          </van-collapse-item>
        </van-collapse>
        <van-row v-else-if="type==='table'">
          <van-cell>
            <van-col :span=(24/tabColumns.length) v-for="(item, index) in tabColumns" :key="index">{{item.label}}</van-col>
          </van-cell>
          <van-cell v-for="(listItem, index) in list" :key="index">
            <van-col :span=(24/tabColumns.length) v-for="(tabItem, index) in tabColumns" :key="index">{{listItem[tabItem.prop]}}</van-col>
          </van-cell>
        </van-row>
        <van-row v-else-if="type==='panel'" v-for="(listItem, index) in list" :key="index" style="margin:.2rem">
          <van-panel >
            <van-row slot="header" style="padding:.4rem .4rem 0">
              <van-col :span="20">{{tabTitle.name?tabTitle.name+listItem[tabTitle.prop]:listItem[tabTitle.prop]}}</van-col>
              <van-col :span="4" style="color:rgb(16,165,74)">{{listItem[tabTitle.status]}}</van-col>
            </van-row>
            <van-row style="padding:.2rem .5rem;background-color: white;">
              <van-col :span="24">
                <dl v-for="(tabItem, index1) in tabColumns" :key="index1">
                  <dt style="float:left;color:black;">{{tabItem.label}}：</dt>
                  <dd>{{listItem[tabItem.prop]?listItem[tabItem.prop]:'未知'}}</dd>
                </dl>
              </van-col>
            </van-row>
            <div slot="footer" style="display:flex;justify-content: flex-end">
              <div v-for="(opItem, index) in operation" :key="index" v-if="show(opItem,listItem)">
                <van-button  :type=opItem.type plain hairline size="small" @click="opItem.method(listItem)">{{opItem.text}}</van-button>
              </div>
            </div>
          </van-panel>
        </van-row>
        <van-row v-else>
          <slot name="list" :list="list"></slot>
        </van-row>
      </van-list>
    </van-pull-refresh>
    <van-row v-if="(list.length === 0)&&(!noFound)" style="display: flex;justify-content: center" >
      <van-col>
        <img src="@/assets/noFound.png" style="width:100px;height:100px;margin-top:120px;" @click="onLoad">
        <p style="text-align: center;font-size:16px;color:rgb(191,191,191);">暂无数据</p>
      </van-col>
    </van-row>
  </div>
</template>

<script>
export default {
  name: "index",
  data() {
    return {
      listModel: {
        PageIndex: 1,
        PageSize: 10,
      },
      activeName: [],
      loading: false,
      finished: false,
      refreshing: false,
      list: [],
      listType: "",
    };
  },
  props: {
    noFound: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    status: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    search: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    type: {
      type: String,
      default: () => {
        return "";
      },
    },
    data: {
      type: Object,
      default: () => {
        return {};
      },
    },
    accordion: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    tabColumns: {
      type: Array,
      default: () => {
        return [];
      },
    },
    tabTitle: {
      type: Object,
      default: () => {
        return null;
      },
    },
    finishedText: {
      type: String,
      default: () => {
        return "";
      },
    },
    loadingText: {
      type: String,
      default: () => {
        return "";
      },
    },
    operation: {
      type: Array,
      default: () => {
        return [];
      },
    },
    request: {
      type: String,
      default: () => {
        return "";
      },
    },
  },
  watch: {},
  computed: {},
  methods: {
    show(row, item) {
      for (const key in row) {
        if (key === "show") {
          // 判断是否存在if判断
          return row.show(item);
        } else {
          return true;
        }
      }
    },
    onRefresh() {
      this.refreshing = true;
      this.listType = "refresh";
      this.listModel = {
        PageIndex: 1,
        PageSize: this.listModel.PageIndex * this.listModel.PageSize,
      };
      setTimeout(() => {
        this.onLoad();
      }, 200);
    },
    onLoad() {
      const params = {
        PageIndex: this.listModel.PageIndex,
        PageSize: this.listModel.PageSize,
      };
      const data = Object.assign(params, this.data);
      this.$post(this.request, data).then((res) => {
        if (res.Data.List) {
          if (this.listType === "refresh") {
            this.list = res.Data.List;
            this.refreshing = false;
            this.listType = "";
          } else {
            this.list = this.list.concat(res.Data.List);
            this.loading = false;
            this.refreshing = false;
            if (res.Data.Total < 10) {
              this.finished = true;
              return false;
            } else {
              this.listModel.PageIndex++;
            }
            if (res.Data.List.length === 0) {
              this.finished = true;
              return false;
            }
          }
        }
      });
    },
  },
  mounted() {},
  created() {},
  components: {},
};
</script>

<style scoped lang="less">
.van-button {
  margin: 0.1rem 0.5rem;
}
</style>
